export default __webpack_public_path__ + "media/images/logos/consultancy_logo-ae17fb6229b26b4ce68f91bbd151b46a.svg";